class CustomerAuth extends HTMLElement {
    constructor() {
        super();

        this.auth = this;

        // Delegated on document.body (instead of binding directly to the matched
        // elements) because the header icons live inside a section that the
        // Shopify theme editor re-renders via AJAX whenever any section's settings
        // change. That replaces the icon elements with fresh ones that never had a
        // listener attached, since this custom element (rendered once, outside the
        // header section) only runs its constructor once on initial page load.
        // Delegation keeps working no matter how many times those icons get
        // replaced, since it only cares about the selector, not the specific node.
        document.body.addEventListener('click', (event) => {
            if (event.target.closest('[data-open-auth-popup]')) {
                this.setOpenPopup(event);
                return;
            }

            if (event.target.closest('[data-close-auth-popup]')) {
                this.setClosePopup(event);
                return;
            }

            if (event.target.closest('[data-open-auth-sidebar]')) {
                this.setOpenSidebar(event);
                return;
            }

            if (event.target.closest('[data-close-auth-sidebar]')) {
                this.setCloseSidebar(event);
                return;
            }
        });

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    setOpenPopup(event){
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('template-customers-login')) {
            $('html, body').animate({
                scrollTop: 0
            }, 700);
        } else {
            document.body.classList.add('auth-popup-show');
        }
    }

    setClosePopup(event){
        event.preventDefault();
        event.stopPropagation();

        document.body.classList.remove('auth-popup-show');
    }

    setOpenSidebar(event){
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('template-customers-login')) {
            $('html, body').animate({
                scrollTop: 0
            }, 700);
        } else {
            document.body.classList.add('auth-sidebar-show');
        }
    }

    setCloseSidebar(event){
        event.preventDefault();
        event.stopPropagation();

        document.body.classList.remove('auth-sidebar-show');
    }
    
    onBodyClickEvent(event){
        if(document.body.classList.contains('auth-popup-show')){
            if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-auth-popup]').length === 0)){
                this.setClosePopup(event);
            }
        }
        
        if(document.body.classList.contains('auth-sidebar-show')){
            if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-auth-sidebar]').length === 0)){
                this.setCloseSidebar(event);
            }
        }
    }
}

customElements.define('customer-auth', CustomerAuth);